// Fixed category filter order for the Stipulations panel (matches categoryCode
// values returned by the BFF). "All Stips" is a client-side sentinel, not a
// real categoryCode, and always renders last.
export const STIPULATION_CATEGORIES = [
  "Income",
  "Bank",
  "Residence",
  "Vehicle",
  "Financial",
  "References",
  "Status",
  "Other Backend Products",
] as const;

export type StipulationCategory = (typeof STIPULATION_CATEGORIES)[number];

export const ALL_STIPULATION_CATEGORIES = "all";

/**
 * The Stipulations panel's category filter starts on "All Stips" on page
 * load — it only narrows to a specific category once the analyst actually
 * scrolls (past a small threshold) or starts typing into the Signers form.
 * See `stipulationCategoryStore`'s `armed` flag.
 */
export const DEFAULT_STIPULATION_CATEGORY = ALL_STIPULATION_CATEGORIES;

/** Maps each category to its corresponding workbenchScreen value. */
export const CATEGORY_TO_WORKBENCH_SCREEN: Record<StipulationCategory, string> = {
  Income: "INCOME",
  Bank: "BANK",
  Residence: "RESIDENCE",
  Vehicle: "VEHICLE",
  Financial: "FINANCE",
  References: "REFERENCE",
  Status: "STATUS",
  "Other Backend Products": "OBP",
};

/** The subset of categories that have a corresponding scrollable section in the Signers card. */
export type ScrollSpySection = Extract<StipulationCategory, "Income" | "Bank" | "Residence">;

/** Which applicant(s) a scroll-tied category's visible stips should be scoped to. */
export type StipulationApplicantScope = "driver" | "secondSigner" | "both";
